/*
 * seminar-cart-guard.js
 * ---------------------------------------------------------------------------
 * Cart-side enforcement for seminar products (cart page + cart drawer).
 *
 * Seminar line items are marked in Liquid with two data attributes on their
 * quantity input:
 *   data-seminar-item="true|false"      -> line came from a seminar product
 *   data-seminar-has-info="true|false"  -> the 2nd-participant info is present
 *
 * Rules enforced here:
 *   1. A seminar line WITHOUT 2nd-participant info is capped at quantity 1, so
 *      the customer cannot bump it to 2 inside the cart (where the form does
 *      not exist). A line WITH info is capped at 2.
 *   2. Checkout is blocked if any seminar line has quantity >= 2 without info.
 *
 * Because the cart re-renders via the Sections API (which wipes JS-applied
 * attributes), caps are re-applied on DOM mutations, and checkout is guarded
 * through capture-phase delegation so it survives re-renders.
 */
(function () {
  var SELECTOR = 'input[data-seminar-item="true"]';
  var MESSAGE =
    'セミナー商品で数量が2の明細に、2人目の参加者情報が入力されていません。' +
    'お手数ですが商品ページで数量を2にして2人目の情報をご入力のうえ、カートに追加し直してください。';

  function seminarInputs() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function hasInfo(input) {
    return input.dataset.seminarHasInfo === 'true';
  }

  function isInvalid(input) {
    var qty = parseInt(input.value, 10) || 0;
    return qty >= 2 && !hasInfo(input);
  }

  /* Re-apply the per-line quantity cap (1 without info, 2 with info). */
  function applyCaps() {
    seminarInputs().forEach(function (input) {
      var cap = hasInfo(input) ? 2 : 1;
      input.setAttribute('max', String(cap));
      input.dataset.max = String(cap);
    });
  }

  function anyInvalid() {
    return seminarInputs().some(isInvalid);
  }

  function showMessage(button) {
    var anchor = button || document.getElementById('checkout') || document.getElementById('CartDrawer-Checkout');
    if (!anchor) {
      window.alert(MESSAGE);
      return;
    }
    var container = anchor.closest('.cart__ctas') || anchor.parentElement;
    var box = container.querySelector('.seminar-cart-error');
    if (!box) {
      box = document.createElement('div');
      box.className = 'seminar-cart-error';
      box.setAttribute('role', 'alert');
      box.style.margin = '0 0 1.2rem';
      box.style.padding = '1rem 1.2rem';
      box.style.fontSize = '1.3rem';
      box.style.color = 'rgb(200 40 40)';
      box.style.background = 'rgba(200, 40, 40, 0.08)';
      box.style.border = '0.1rem solid rgba(200, 40, 40, 0.4)';
      box.style.borderRadius = '0.4rem';
      container.insertBefore(box, container.firstChild);
    }
    box.textContent = MESSAGE;
    box.hidden = false;
    box.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }

  function guard(event, button) {
    applyCaps();
    if (anyInvalid()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showMessage(button);
      return false;
    }
    return true;
  }

  /* Block clicks on either checkout button (capture so we run first). */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest
        ? event.target.closest('#checkout, #CartDrawer-Checkout, button[name="checkout"]')
        : null;
      if (!button) return;
      guard(event, button);
    },
    true
  );

  /* Backstop: block the cart form submission itself. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (form.id === 'cart' || form.id === 'CartDrawer-Form') {
        guard(event, null);
      }
    },
    true
  );

  /* Re-apply caps on load and whenever the cart re-renders. */
  var scheduled = false;
  function scheduleCaps() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      applyCaps();
    });
  }

  function start() {
    applyCaps();
    if (window.MutationObserver) {
      new MutationObserver(scheduleCaps).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
